import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SharedLoginPageModule } from '~/pages/login/shared/modules/sharedModule';
import { PageNotFoundPageComponent } from '~/pages/login/pageNotFound/pageNotFound';

export const ROUTES:Routes = [
    {
        path: '',
        component: PageNotFoundPageComponent
    }
];

@NgModule({
    imports: [
        SharedLoginPageModule,
        RouterModule.forChild(ROUTES)
    ],
    declarations: [
        PageNotFoundPageComponent
    ],
    exports: [
        PageNotFoundPageComponent
    ]
})

export class PageNotFoundPageModule {
}
